<template>
  <el-dialog title="病虫害防治" :visible.sync="show" width="60%">
    <div style="height: 360px">
      <el-alert type="success" :closable="false">
        病虫害防治请使用配套手机端进行识别和获取防治指导。
      </el-alert>
    </div>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      show: false,
    }
  },
  methods: {
    open() {
      this.show = true
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/welcome/LandGuideDiseaseDialog.vue